import { config } from '../config.js';

interface TrackingEvent {
  userId: string;
  eventType: 'page_view' | 'link_click';
  linkId?: string;
  referrer?: string;
}

class TrackingService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = config.apiUrl;
  }

  track(event: TrackingEvent): void {
    fetch(`${this.baseUrl}/api/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event),
    });
  }

  pageView(userId: string, referrer?: string): void {
    this.track({
      userId,
      eventType: 'page_view',
      referrer: referrer || document.referrer || 'direct',
    });
  }

  linkClick(userId: string, linkId: string, referrer?: string): void {
    this.track({
      userId,
      eventType: 'link_click',
      linkId,
      referrer: referrer || document.referrer || 'direct',
    });
  }
}

export const tracker = new TrackingService();
